// @flow

import * as React from "react";
import task from "./task";
import Block from "../../components/Block/Block";
import Page from "../../components/Page/Page";
import Article from "../../components/Article/Article";

import "./instructions.css";

const PolitifactInstructions = () => {
  const question = task.renderQuestion({
    id: "",
    question:
      "House Dems introduce bill to remove citizenship requirement from presidency.",
    answer: false,
    responseTimesInSeconds: [],
    metadata: {
      speaker: "Blogger",
      date: "2017-09-18",
      context: "in a blog post"
    },
    project: { id: "", name: "", template: "" }
  });
  return (
    <Page>
      <Article>
        <h1>Fact-Checking Political Statements</h1>
        <p>
          In each round of the game, you will see a political statement like
          this:
        </p>
        <Block className="Politifact-Instructions-Example">{question}</Block>

        <h2>Instructions</h2>
        <ol>
          <li>
            Your task is to evaluate the likelihood that the statement is true.
          </li>
          <li>
            {" "}
            You’ll first make a quick guess (after 30 seconds) and then you’ll
            guess again after 90 seconds and 6 minutes.
          </li>
          <li>
            <b>
              You’ll have access to a Google search tool. You are not allowed
              use Google in a separate window or to switch tabs while working on
              the task.{" "}
            </b>
          </li>
        </ol>
        <p>
          Do you understand the instructions? If not, ping us using the
          messenger in the bottom right corner.
        </p>
      </Article>
    </Page>
  );
};

export default PolitifactInstructions;



// WEBPACK FOOTER //
// ./src/templates/politifact/instructions.js